<template>
  <div>
    <h1
      id="focus-target"
      class="p-x py-2 focus-b"
      :class="[`bg-${palette.primary}`]"
      v-html="category.heading"
    />

    <nav aria-label="Subject">
      <ol>
        <li v-for="item in orderedSubjectList" :key="item.letter">
          <div
            :id="item.letter"
            class="tooltip relative p-x py-1 text-xl font-black border-b border-t"
            :class="[`bg-${palette.secondary}`, `border-${palette.primary}`]"
            v-html="item.letter"
          />
          <ol
            :aria-labelledby="item.letter"
            class="subject-list p-x"
            :class="[`bg-${palette.tertiary}`]"
          >
            <li
              v-for="child in item.children"
              :key="child.id"
              class="subject-list__item py-2 border-b"
              :class="[`border-${palette.secondary}`]"
            >
              <RouterLink
                :to="child.slug"
                class="block focus-b"
                v-html="child.title"
              />
            </li>
          </ol>
        </li>
      </ol>
    </nav>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Subjects',

  props: {
    category: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState(['touch', 'mobile']),
    ...mapGetters(['subjects']),

    palette() {
      return this.category.palette
    },

    orderedSubjectList() {
      const firstLetters = this.subjects.map(item => {
        return item.title.charAt(0)
      })
      const uniqueSet = [...new Set(firstLetters)]
      const list = uniqueSet.map(item => {
        const children = this.subjects.filter(o => o.title.startsWith(item))
        const alphabetizedChildren = children.sort((a, b) =>
          a.title.localeCompare(b.title)
        )
        return {
          letter: item,
          children: alphabetizedChildren
        }
      })
      return list.sort((a, b) => a.letter.localeCompare(b.letter))
    }
  }
}
</script>

<style>
@screen md {
  .subject-list {
    columns: 2;
  }

  .subject-list__item {
    break-inside: avoid;
  }
}
</style>
